import React, {useState} from 'react';
import { Flex } from "antd";
import {StyledCard} from "./Header.styled";
import {useLocation} from "react-router-dom";
import {BackButton} from "../../components";

const Header = () => {
    const [open, setOpen] = useState<boolean>(false)
    const [activeTitle, setActiveTitle] = useState<string>('')
    const onCansel = () => {
        setOpen(false)
    }
    return (
        <StyledCard>
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"middle"} align={"center"}>
                        <BackButton/>
                    </Flex>
                </Flex>
            </Flex>
        </StyledCard>
    )

};

export default Header;